export const KLEAR_SUCCESS_EMAIL = 'success@klearbusiness.com'
export const KLEAR_NOTIFICATIONS_EMAIL = 'notifications@klearbusiness.com'
export const KLEAR_SUPPORT_EMAIL = 'support@klearbusiness.com'
export const KLEAR_SALES_EMAIL = 'sales@klearbusiness.com'
export const KLEAR_OPS_ALERTS_STAGING_EMAIL = 'ops-alerts-staging@klearbusiness.com'

export function klearEmailFrom(email: string): string {
  return `Klear <${email}>`
}

export const KLEAR_SUCCESS_EMAIL_FROM = klearEmailFrom(KLEAR_SUCCESS_EMAIL)
export const KLEAR_NOTIFICATIONS_EMAIL_FROM = klearEmailFrom(KLEAR_NOTIFICATIONS_EMAIL)
export const KLEAR_SUPPORT_EMAIL_FROM = klearEmailFrom(KLEAR_SUPPORT_EMAIL)
